import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IPermissionReducer {
  motion: PermissionState;
}

export enum PermissionState {
  DENIED = -1,
  NOT_REQUIRED = 0,
  REQUIRED = 1,
  GRANTED = 2,
}

const initialState: IPermissionReducer = {
  motion: PermissionState.NOT_REQUIRED,
};

const permissionSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    updatePermission(state, action: PayloadAction<IPermissionReducer>) {
      state = { ...state, ...action.payload };
    },
  },
  //   extraReducers: builder => {
  //     builder
  //       .addCase(searchRequest.pending, (state, action: any) => {
  //         state.loading = LoadingState.LOADING;
  //       })
  //       .addCase(searchRequest.rejected, (state, action: any) => {
  //         state.loading = LoadingState.ERROR;
  //       })
  //       .addCase(searchRequest.fulfilled, (state, action: PayloadAction<IModuleBasicDAO[]>) => {
  //         state.loading = LoadingState.ERROR;
  //         state.results = action.payload;
  //       });
  //   },
});

export const { updatePermission } = permissionSlice.actions;

export default permissionSlice.reducer;
